(function () {
"use strict";
const VAT = 0.20, UPFRONT = 0.4144, POOL_LIMIT = 300, DISC = 0.90;
const LADDER_A = [[1, 3.50, 3.50], [11, 3.00, 3.00], [50, 2.00, 2.90], [100, 1.50, 2.50]];
const LADDER_B = [[0.5, 4.75], [1, 8.71 / 1.2], [2, 11.84 / 1.2]];
const LADDER_C = [[0.25, 2.00], [1, 3.50], [2, 5.00], [4, 7.50], [5, 9.125], [10, 16.00], [20, 28.00], [50, 64.50]];
const FLOOR_SIM = 0.32072, FLOOR_GB = 1.61640;

const band = (n, t) => t.reduce((v, row) => (n >= row[0] ? row : v), t[0]);
const floor2 = x => Math.floor(x * 100 + 1e-9) / 100;
const ceil2  = x => Math.ceil(x * 100 - 1e-9) / 100;
const round2 = x => Math.round(x * 100) / 100;

function ladder(t, d) {
  if (d <= t[0][0]) return t[0][1];
  const n = t.length, [xl, yl] = t[n - 1], [xp, yp] = t[n - 2];
  if (d >= xl) return yl + (d - xl) * (yl - yp) / (xl - xp);
  for (let i = 0; i < n - 1; i++) {
    const [x0, y0] = t[i], [x1, y1] = t[i + 1];
    if (d >= x0 && d <= x1) return y0 + (y1 - y0) * (d - x0) / (x1 - x0);
  }
}

function quote(sims, poolGB) {
  if (!Number.isInteger(sims) || sims < 1 || sims > 100000 || !Number.isFinite(poolGB) || poolGB < 0.5) throw new RangeError("Invalid SIM count or pool");
  const d = poolGB / sims;
  const out = { sims, poolGB, perSimGB: d, upfront: round2(sims * UPFRONT) };
  if (poolGB > POOL_LIMIT) { out.payg = { poa: true }; out.m24 = { poa: true }; return out; }
  const [, simFee, perGB] = band(sims, LADDER_A);
  const ladderA = sims * simFee + poolGB * perGB;
  const ladderB = sims * ladder(LADDER_B, d);
  const ladderC = sims * ladder(LADDER_C, d);
  const payg = floor2(DISC * Math.min(ladderA, ladderB));
  const floor = ceil2(sims * FLOOR_SIM + poolGB * FLOOR_GB);
  const m24 = Math.max(Math.min(floor2(DISC * ladderC), floor2(DISC * payg)), floor);
  out.ladders = { ladderA, ladderB, ladderC, floor };
  out.payg = { poa: false, price: payg, incVat: payg * (1 + VAT), perSim: payg / sims, perGB: payg / poolGB };
  out.m24 = m24 > ladderC
    ? { poa: true }
    : { poa: false, price: m24, incVat: m24 * (1 + VAT), perSim: m24 / sims, perGB: m24 / poolGB, contractValue: m24 * 24 };
  return out;
}

const api = {quote, floor2, ceil2, round2};
if (typeof module !== "undefined" && module.exports) module.exports = api;
else globalThis.SenecaPricing = api;
})();
